import { EditorControl } from '../../common/components/lexical';
import { OnLexicalError } from '../../common/components/lexical/types';
import { DebouncedFunc } from 'lodash';
import React, { useRef } from 'react';
import { Control } from 'react-hook-form';
import { NarrativeInput, NarrativeInputFieldValues } from '../components/narrative-input';

export interface EventPanelNewEventNarrativeInputProps {
    onReplaceVehicles?: (vehicles: string[]) => void | DebouncedFunc<(vehicles: string[]) => void>;
    onLexicalError?: OnLexicalError;
    control: Control<NarrativeInputFieldValues, unknown>;
    fieldName?: string;
    mode?: 'read-only';
}

export function EventPanelNewEventNarrativeInput({
    control,
    fieldName,
    onReplaceVehicles,
    onLexicalError,
    mode,
}: EventPanelNewEventNarrativeInputProps): React.JSX.Element {
    const editorControlRef = useRef<EditorControl>();

    return (
        <NarrativeInput
            isNewEvent={true}
            fieldName={fieldName}
            agencyEventId={0}
            data-testid="NARRATIVE_INPUT"
            editorControlRef={editorControlRef}
            control={control}
            onLexicalError={onLexicalError}
            onReplaceVehicles={onReplaceVehicles}
            mode={mode}
        />
    );
}

export default EventPanelNewEventNarrativeInput;
